import DOMPurify from 'dompurify';

export const IMPLEMENTATION_PROPOSAL_ALLOWED_HTML_TAGS = [
  'p',
  'strong',
  'em',
  'br',
  'ul',
  'ol',
  'li',
  'table',
  'thead',
  'tbody',
  'tr',
  'th',
  'td',
  'del',
  'ins',
];

export const sanitizeImplementationProposalHtml = (html?: string): string =>
  DOMPurify.sanitize(html ?? '', {
    ALLOWED_TAGS: IMPLEMENTATION_PROPOSAL_ALLOWED_HTML_TAGS,
    ALLOWED_ATTR: [],
    ALLOW_ARIA_ATTR: false,
    ALLOW_DATA_ATTR: false,
    FORBID_TAGS: ['script', 'style', 'iframe'],
    FORBID_ATTR: ['style', 'href', 'src', 'xlink:href'],
  });
